module.exports = __webpack_public_path__ + "static/media/k3.f0be3018.jpg";